import * as T from 'three';
import {GLTFLoader} from 'three/addons/loaders/GLTFLoader.js';

// Preserve authored materials/UVs, bake glTF node transforms, center the trunk
// footprint and put the base at ground level. Four units matches the old trees.
export function prepareEnvironmentTree(gltf){
 const root=gltf.scene;root.updateMatrixWorld(true);
 const bounds=new T.Box3().setFromObject(root),size=bounds.getSize(new T.Vector3());
 if(bounds.isEmpty()||!Number.isFinite(size.y)||size.y<=0)throw new Error('Invalid tree bounds');
 const center=bounds.getCenter(new T.Vector3()),scale=4/size.y;
 const normalize=new T.Matrix4().makeScale(scale,scale,scale).multiply(new T.Matrix4().makeTranslation(-center.x,-bounds.min.y,-center.z));
 const parts=[];
 root.traverse(object=>{
  if(!object.isMesh)return;
  if(Array.isArray(object.material)||!object.material.map)throw new Error('Tree is missing an authored texture');
  const geometry=object.geometry.clone().applyMatrix4(new T.Matrix4().multiplyMatrices(normalize,object.matrixWorld));
  parts.push({geometry,material:object.material});
 });
 if(!parts.length)throw new Error('Tree has no meshes');
 // GLTFLoader can log and swallow texture errors; explicitly reject partial trees.
 if(!parts.some(part=>part.material.normalMap))throw new Error('Tree is missing its bark normal texture');
 return {parts};
}

export async function loadEnvironmentTrees(loader=new GLTFLoader()){
 const names=['CommonTree_5','Pine_5'];
 const trees=await Promise.all(names.map(name=>loader.loadAsync(`/assets/nature/${name}.gltf`)));
 const prepared=Object.fromEntries(trees.map((tree,i)=>[names[i],prepareEnvironmentTree(tree)]));
 // These two source models reference the same bark images; reuse one GPU
 // texture of each kind rather than uploading duplicate 2048px images.
 const bark=tree=>tree.parts.find(part=>part.material.normalMap).material;
 const common=bark(prepared.CommonTree_5),pine=bark(prepared.Pine_5);
 for(const key of ['map','normalMap']){if(pine[key]!==common[key])pine[key].dispose();pine[key]=common[key];}
 return prepared;
}
